import React from "react";
import { CreateOrGenerateContainer } from "../../../containers";

const CreateOrGenerate = (props) => {
  return <CreateOrGenerateContainer {...props} />;
};

export default CreateOrGenerate;
